import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState, apsAssignedSelector } from '..';
import { ApsAssignedList } from 'src/app/models/aps-assigned-list';
import { FetchApsAssigned } from './aps_assinged.actions';
import { RxdbService } from 'src/app/services/rxdb.service';

@Injectable({
  providedIn: 'root'
})

export class ApsAssignedFacade {
  apsAssignedList$: Observable<Array<ApsAssignedList>>;

  constructor(private store: Store<AppState>, private rxDB: RxdbService) {
      this.apsAssignedList$ = store.pipe(select(apsAssignedSelector));
  }

  getApsAssignedList() {
    this.store.dispatch(new FetchApsAssigned());
  }

  getApsAssignedCheckOutList(agentId: number, ids?: Array<number>) {
    if (ids !== undefined) {
      return this.rxDB.db.aps_assigned_list.find().where('assigned_agent_id').eq(agentId).where('aps_report_load_id').in(ids).$;
    }
    if (agentId !== undefined) {
      return this.rxDB.db.aps_assigned_list.find().where('assigned_agent_id').eq(agentId).$;
    }
    return this.rxDB.db.aps_assigned_list.find().$;
  }

  getApsAssignedCheckOutListWithObservable(agentId?: number, ids?: Array<number>) {
    if (ids !== undefined) {
      return this.rxDB.db.aps_assigned_list.find().where('assigned_agent_id').eq(agentId).where('aps_report_load_id').in(ids).exec();
    }
    if (agentId !== undefined) {
      return this.rxDB.db.aps_assigned_list.find().where('assigned_agent_id').eq(agentId).exec();
    }
    return this.rxDB.db.aps_assigned_list.find().exec();
  }

  insertApsAssignedCheckOutItem(data: any) {
    this.rxDB.db.aps_assigned_list.upsert({
      ...data,
      aps_report_load_id: data.aps_report_load_id.toString()
    });
  }

  deleteApsAssignedCheckOutItem(ids: Array<string>) {
    this.rxDB.db.aps_assigned_list.find().where('aps_report_load_id').in(ids).remove();
  }

}
